
const Day = (props: any) : JSX.Element => {
  return (
    <div>Day</div>
  )
}
 

export default Day